import {HttpClient} from '@angular/common/http';
import {EventEmitter, Injectable} from '@angular/core';
import {FormControl} from '@angular/forms';
import {BehaviorSubject, Observable, ReplaySubject, Subject, Subscription} from 'rxjs';
import {environment} from '../../environments/environment';
import {UserProfile} from "../../../../fe-common-v2/src/lib/models/admin/user";
import {UserManagementService} from "../../../../fe-common-v2/src/lib/services/user-management.service";
import {EncryptionService} from "../../../../fe-common-v2/src/lib/services/encryption.service";
import {ApiService} from "../../../../fe-common-v2/src/lib/services/api";

export const StrongPasswordRegx: RegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,20}$/;
@Injectable({
    providedIn: 'root'
})
export class MCPHelperService {

    constructor(
        private http: HttpClient,
        private apiService: ApiService,
        private userManagementService: UserManagementService,
    ) {
        this.updateCompanyId();
    }
    public static security: EncryptionService = new EncryptionService();
    public static authUser: any = {};
    public static loginUserData: any = null;
    public static loginUserID = '';
    public static loginUserToken = '';

    invokeFirstComponentFunction = new EventEmitter();
    chartUpdateDataEmitter = new EventEmitter();
    updateSideMenuEmitter = new EventEmitter();
    updateHeaderEmitter = new EventEmitter();
    clearEventSelectionEmitter = new EventEmitter();
    subsVar: Subscription;

    sideMenuListName = new Subject<any>();
    resetSearchValue = new Subject<any>();
    updateScopeTableHeaderVal = new Subject<any>();
    userLanguageSelect = new Subject<any>();
    languageList = new Subject<any>();
    totalCount = new Subject<any>();
    baseUrl: string = environment.api_host;
    languageTranslatorChange: Subject<string> = new Subject<string>();
    changeLogoTranslatorChange: Subject<string> = new Subject<string>();
    setLanguageTranslator = 'it';
    loaderVisibilityChange: Subject<boolean> = new Subject<boolean>();
    loaderVisibilityChange2: Subject<boolean> = new Subject<boolean>();
    hideLoaderChange: Subject<boolean> = new Subject<boolean>();
    listCountData: BehaviorSubject<any>;
    isLoaderVisible = false;
    isLoaderVisible2 = false;
    private httpLoading$ = new ReplaySubject<boolean>(1);
    private countData: any;

    private refreshListSource = new BehaviorSubject<boolean>(true);
    refreshList$ = this.refreshListSource.asObservable();

    companyId: any;
    private rolePermissionCache: { [functionName: string]: any } = {};

    public static getLanguageName(): string {
        const languageData = MCPHelperService.getDataFromStorage('currentLanguage');
        if (languageData) {
            return languageData;
        }
        return null;
    }

    public static onLogOut(): void {
        MCPHelperService.removeDataFromStorage('credentials')
        MCPHelperService.removeDataFromStorage('MCPToken');
        MCPHelperService.removeDataFromStorage('MCPLoggedInUser');
        MCPHelperService.removeDataFromStorage('MCPLoginId');
        MCPHelperService.removeDataFromStorage('defaultSite');
        // localStorage.removeItem('credentials');
        // localStorage.removeItem('MCPToken');
        // localStorage.removeItem('MCPLoggedInUser');
        // localStorage.removeItem('MCPLoginId');
        MCPHelperService.loginUserData = null;
        MCPHelperService.loginUserID = null;
        MCPHelperService.loginUserToken = null;
    }

    public static saveLocalStorage(loginUser): void {
        MCPHelperService.loginUserData = loginUser;
        MCPHelperService.loginUserID = loginUser.id;
        MCPHelperService.loginUserToken = loginUser.token;
        MCPHelperService.removeDataFromStorage('MCPTokenData');
        MCPHelperService.removeDataFromStorage('MCPLoggedInUser');
        MCPHelperService.removeDataFromStorage('MCPLoginId');
        MCPHelperService.setDataInStorage('MCPLoggedInUser', JSON.stringify(loginUser));
        MCPHelperService.setDataInStorage('MCPLoginId', MCPHelperService.loginUserID);
        MCPHelperService.setDataInStorage('MCPTokenData', MCPHelperService.loginUserToken);
    }

    public static getLocalStorage(): void {
        let str:any = MCPHelperService.getDataFromStorage("credentials")
        const loginUser: any = JSON.parse(str);
        if (loginUser) {
            MCPHelperService.loginUserData = loginUser.person;
            MCPHelperService.loginUserID = loginUser.person.id;
            MCPHelperService.loginUserToken = loginUser.token;
        }
    }

    public static getStorage(): void {
        let str:any = MCPHelperService.getDataFromStorage("credentials")
        const loginUser: any = JSON.parse(str);
        if (loginUser) {
            MCPHelperService.loginUserData = loginUser.person;
            MCPHelperService.loginUserID = loginUser.person.id;
            MCPHelperService.loginUserToken = loginUser.token;
        }
    }

    static noWhitespaceValidator(control: FormControl): any {
        const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : {required: true};
    }

    static nameValidator(control: FormControl): { [key: string]: boolean } {
        const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if (control.value && nameRegexp.test(control.value)) {
            return {nameValidator: true};
        }
    }

    toggleLoaderVisibility(isSidebarVisible: boolean): void {
        this.isLoaderVisible = isSidebarVisible;
        this.loaderVisibilityChange.next(this.isLoaderVisible);
    }

    /*isFunctionAvailable(functionId: string): boolean {
        const token = this.userManagementService.getTokenDecoded();
        if ((functionId == null) || ((token?.profile && (token?.profile.includes(UserProfile.SYSTEM) || token?.profile.includes(UserProfile.ADMIN))))) {
            return true;
        } else {
            return (functionId == '*') || (token && token.availableFunctions && token.availableFunctions.includes(functionId));
        }
    }*/

    isFunctionAvailable(functionId: string): boolean {
        const token = this.userManagementService.getTokenDecoded();
        const functions = this.userManagementService.getFunctions()
        if ((functionId == null) || ((token?.profile && (token?.profile?.includes(UserProfile?.SYSTEM) || token?.profile?.includes(UserProfile?.ADMIN))))) {
            return true;
        } else {
            return (functionId == '*') || (!!functions?.find(f => f.value === functionId));
        }
        /*if (token?.functions && token?.functions?.length > 0) {
            return !!token.functions.find(f => f.value === functionId);
        } else {
            return false
            // if ((functionId == null) || ((token?.profile && (token?.profile.includes(UserProfile.SYSTEM) || token?.profile.includes(UserProfile.ADMIN))))) {
            //     return true;
            // } else {
            //     return (functionId == '*') || (token && token.availableFunctions && token.availableFunctions.includes(functionId));
            // }
        }*/
    }

    checkRolePermission(functionName: string): any {
        const functions = this.userManagementService.getFunctions();
        const d = functions?.find(item => item.value == functionName);
        const res = {};
        if (d){
            Object?.keys(d?.operations)?.forEach(operation => {
                res[operation] = d?.operations[operation] != 0;
            });
        }
        return res;
    }

    /*checkRolePermission(functionName: string): any {
        if (this.rolePermissionCache?.hasOwnProperty(functionName)) {
            return this.rolePermissionCache[functionName];
        }
        const token = this.userManagementService.getTokenDecoded();
        const d = token?.functions?.find(item => item.value == functionName);
        const res = {};
        if (d){
            Object?.keys(d?.operations)?.forEach(operation => {
                res[operation] = d?.operations[operation] != 0;
            });
        }
        this.rolePermissionCache[functionName] = res;
        return res;
    }*/

    setListCount(countData: any): void {
        this.countData = countData;
        this.listCountData?.next(this.countData);
    }

    deleteMultiScopes(scope: any) {
        this.updateCompanyId();
        return this.apiService.post('/v2/user-manager/company/' + this.companyId + '/delete/scopes', scope);
    }

    setHideLoader(hide: boolean): void {
        this.hideLoaderChange.next(hide);
    }

    toggleLoaderVisibility2(isSidebarVisible: boolean): void {
        this.isLoaderVisible2 = isSidebarVisible;
        this.loaderVisibilityChange2.next(this.isLoaderVisible2);
    }

    // tslint:disable-next-line:typedef
    getListCount() {
        return this.countData?.asObservable();
    }

    // Global loader
    httpProgress(): Observable<boolean> {
        return this.httpLoading$.asObservable();
    }

    // tslint:disable-next-line:typedef
    setHttpProgressStatus(inprogess: boolean) {
        this.httpLoading$.next(inprogess);
    }

    languageTranslator(isSidebarVisible: string): void {
        this.setLanguageTranslator = isSidebarVisible;
        this.languageTranslatorChange.next(this.setLanguageTranslator);
    }

    onFirstComponentButtonClick() {
        this.invokeFirstComponentFunction.emit();
    }

    chartUpdateData() {
        this.chartUpdateDataEmitter.emit(true);
    }

    updateSideMenuData() {
        this.updateSideMenuEmitter.emit();
    }
    updateHeaderData(data:any) {
        this.updateHeaderEmitter.emit(data);
    }

    clearEventSelection(stepName: string) {
        this.clearEventSelectionEmitter.emit(stepName);
    }

    serviceCategoryList(data: any = null): Observable<any> {
        return this.apiService.post('v2/mqs-service/list', data);
    }

    signupSupplierDocument(data: any): Observable<any> {
        return this.apiService.post('/v2/procurement/document/list', data);
    }

    getCMSDetails(data: any): Observable<any> {
        return this.apiService.post('/v2/dashboard/cms', data);
    }

    getCMSPageDetails(data: any): Observable<any> {
        return this.apiService.post('/v2/cms/get', data);
    }

    getFitIndexDetails(data: any): Observable<any> {
        return this.apiService.post('/v2/quiz/metric/survey/view', data);
    }

    getClientDashboardData(data: any): Observable<any> {
        return this.apiService.post('/v2/user-manager/company/dashboard/count', data);
    }

    getEditEventTypeData(eventId, id): Observable<any> {
        return this.apiService.post('/v2/user-manager/company/edit/event/type', {eventId, id});
    }

    // Multiple Delete APIs

    deleteMultiArea(name: any) {
        this.updateCompanyId();
        return this.apiService.post('/v2/user-manager/company/' + this.companyId + '/areas/delete', name);
    }

    deleteMultiSites(id: any) {
        return this.apiService.post('/v2/site-manager/delete/sites', id);
    }

    deleteMultiRoles(name: any) {
        this.updateCompanyId();
        return this.apiService.post('/v2/user-manager/company/' + this.companyId + '/roles/delete', name);
    }

    deleteMultiJobTitle(title: any) {
        this.updateCompanyId();
        return this.apiService.post('/v2/user-manager/company/' + this.companyId + '/jobTitles/delete', title);
    }

    deleteMultiDispute(name: any) {
        this.updateCompanyId();
        return this.apiService.post('/v2/user-manager/company/' + this.companyId + '/disputes/delete', name);
    }

    deleteMultiDegrees(id: any) {
        return this.apiService.post('/v2/dashboard/delete/degrees', id);
    }

    deleteMultiPeopleGroups(id: any) {
        return this.apiService.post('/v2/user-manager/delete/groups', id);
    }

    deleteMultiAccounts(id: any) {
        return this.apiService.post('/v2/user-manager/delete/accounts', id);
    }

    deleteMultiTestimonials(id: any) {
        return this.apiService.post('/v2/user-manager/delete/accounts', id);
    }

    deleteMultiAlerts(id: any) {
        return this.apiService.post('/v2/delete/alerts', id);
    }

    deleteMultiPushNotifications(id: any) {
        return this.apiService.post('/v2/recruiting-management/delete/push-notifications', id);
    }

    deleteMultiTouchPoints(id: any) {
        return this.apiService.post('/v2/touchpoint/deletes', id);
    }

    deleteMultiPeople(id: any) {
        return this.apiService.post('/v2/user-manager/delete/persons', id);
    }

    deleteMultiPeopleRNP(data: any, scope: any) {
        return this.apiService.post('/v2/user-manager/delete/persons/' +  scope, data);
    }

    deleteMultiCategory(id: any) {
        return this.apiService.post('/v2/info-category/deletes', id);
    }

    deleteMultiInformation(id: any) {
        return this.apiService.post('/v2/info/deletes', id);
    }

    deleteMultiCandidates(id: any) {
        return this.apiService.post('/v2/recruiting-management/candidates/delete', id);
    }

    deleteMultiApplications(id: any) {
        return this.apiService.post('/v2/recruiting-management/applications/delete', id);
    }

    deleteMultiOpenings(id: any) {
        return this.apiService.post('/v2/recruiting-management/jobs/delete', id);
    }

    deleteMultiMetrics(id: any) {
        return this.apiService.post('/v2/quiz/metrics/deletes', id);
    }

    deleteMultiQuestions(id: any) {
        return this.apiService.post('/v2/questions/multiple/delete', id);
    }

    deleteMultiSurvey(id: any) {
        return this.apiService.post('/v2/quiz/survey/delete', id);
    }

    deleteMultiUniversity(id: any) {
        return this.apiService.post('/v2/dashboard/universities/delete', id);
    }

    public static setDataInStorage(key,value,browserStorage?) {
        if(!browserStorage){
            browserStorage = MCPHelperService.security.decryptionAES(localStorage.getItem('browserStorage')) || MCPHelperService.security.decryptionAES(sessionStorage.getItem('browserStorage'));
        }
        if(browserStorage == 'sessionStorage'){
            MCPHelperService.security.setDataToSessionStorage(key,value)
            return true;
        }else{
            MCPHelperService.security.setDataToLocalStorage(key,value)
            return true;
        }
    }

    deleteMultiEvent(id: any, companyId) {
        return this.apiService.post('/v2/user-manager/company/event/types/delete', {
            id,
            companyId
        });
    }

    deleteMultiCountry(id: any) {
        return this.apiService.post('/v2/procurement/countries/delete', {id});
    }

    deleteMultiRegion(id: any) {
        return this.apiService.post('/v2/procurement/multiple/states/delete', {id});
    }

    deleteMultiCities(id: any) {
        return this.apiService.post('/v2/procurement/multiple/city/delete', {id});
    }

    deleteMultiResourceGroups(id: any) {
        return this.apiService.post('/v2/booking/resource/type/delete', id);
    }

    deleteMultiContactUs(id: any) {
        return this.apiService.post('/v2/public-website/contact-us/delete', id);
    }

    deleteExecutiveCommitteeTags(id: any) {
        return this.apiService.post('/v2/user-manager/executive-committe/delete', id);
    }

    back() {
        history.back();
    }

    refreshReservationList(): void {
        this.refreshListSource.next(true);
    }

    public static getDataFromStorage(key,browserStorage?) {
        var value;
        if(!browserStorage){
            browserStorage = MCPHelperService.security.getDataFromLocalStorage('browserStorage') || MCPHelperService.security.getDataFromSessionStorage('browserStorage');
        }
        if(browserStorage == 'sessionStorage'){
            value = MCPHelperService.security.getDataFromSessionStorage(key)
        }else{
            value = MCPHelperService.security.getDataFromLocalStorage(key)
        }
        return value;
    }

    public static removeDataFromStorage(key,browserStorage?) {
        if(!browserStorage){
            browserStorage = MCPHelperService.security.getDataFromLocalStorage('browserStorage') || MCPHelperService.security.getDataFromSessionStorage('browserStorage');
        }
        if(browserStorage == 'sessionStorage'){
           MCPHelperService.security.removeDataFromSessionStorage(key)
        }else{
           MCPHelperService.security.removeDataFromLocalStorage(key)
        }
    }

    private updateCompanyId() {
        let str = MCPHelperService.getDataFromStorage("credentials")
        const credentials = str;
        if (credentials) {
            const authUser: any = JSON.parse(credentials);
            this.companyId = authUser.person.companyId;
        }
    }

    getDefaultOperationalSite():any{
        let str = MCPHelperService.getDataFromStorage("defaultSite")
        if (str) {
            return  JSON.parse(str);
        }
    }
    getContrastYIQ(hexColor: string): string {
        const r = parseInt(hexColor.substr(1, 2), 16);
        const g = parseInt(hexColor.substr(3, 2), 16);
        const b = parseInt(hexColor.substr(5, 2), 16);
        const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return yiq >= 128 ? '' : 'booking-text-white';
    }
    removeInactiveAreas(areas: any[]): any[] {
        return areas
            .filter(area => area.status !== 0)
            .map(area => ({
                ...area,
                areas: this.removeInactiveAreas(area.areas || [])
            }));
    }
}
